import React from 'react'
import Panel from '@common/Panel'
import { Flex } from 'hljd'
import style from './style.module.less'

export default ({ item, title, children, icon, extra }) => {
  const { id, created_at } = item || {}

  return (
    <Panel
      key={id}
      title={
        title || (
          <Flex vc>
            <img src={icon} className={style.icon} />
            <span className={style.title}>{item.title}</span>
          </Flex>
        )
      }
      extra={extra === undefined ? created_at : extra}
    >
      {children}
    </Panel>
  )
}
